export default __webpack_public_path__ + "static/media/ExpandSidebarIcon.48f6cb7b.svg";